export enum EMappedTypeOffer {
  OFFER = 'offer',
  PERSONALIZED = 'personalized',
  MULTI = 'multi',
}
